import { handleDispatchResult } from "@utils/helpers/handleDispatchResult";
import * as Api from "@modules/api";

import { store } from "../store";
import { asyncActions, actions } from "./slices";
import { GetProductGroupByPromoCodeInput } from "./types";

export const getCustomerQuota = async (
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(asyncActions.getCustomerQuotaAsync());

  return handleDispatchResult(res, onSuccess);
};

export const getProductGroupDefault = async (
  onSuccess?: (
    res: Api.Server.ProductGroupWithProductsOutput
  ) => void | Promise<void>
) => {
  const res = await store.dispatch(asyncActions.getProductGroupDefaultAsync());

  return handleDispatchResult(res, onSuccess);
};

export const getProductGroupByPromoCode = async (
  body: GetProductGroupByPromoCodeInput,
  onSuccess?: (
    res: Api.Server.ProductGroupWithProductsOutput
  ) => void | Promise<void>,
  onFailure?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    asyncActions.getProductGroupByPromoCodeAsync(body)
  );

  return handleDispatchResult(res, onSuccess, onFailure);
};

export const getFeaturesByPlanId = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(asyncActions.getFeaturesByPlanIdAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const createMyPaymentIntent = async (
  body: Api.Server.CreateMyStripePaymentIntentInput,
  onSuccess?: () => void | Promise<void>,
  onFailure?: (error: any) => void | Promise<void>
) => {
  const res = await store.dispatch(
    asyncActions.createMyPaymentIntentAsync(body)
  );

  return handleDispatchResult(res, onSuccess, onFailure);
};

export const createBehaviourEvent = async (
  body: Api.Server.CreateBehaviourEventInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    asyncActions.createBehaviourEventAsync(body)
  );

  return handleDispatchResult(res, onSuccess);
};

export const redeemCredit = async (
  body: Api.Server.RedeemContentEntityWithPointsInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(asyncActions.redeemCreditAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const clearProductGroupByPromoCode = async () => {
  store.dispatch(actions.clearProductGroupByPromoCode());
};

export const getProductGroupContent = async (
  onSuccess?: (
    res: Api.Server.ProductGroupWithProductsOutput
  ) => void | Promise<void>,
  onFailure?: () => void | Promise<void>
) => {
  const res = await store.dispatch(asyncActions.getProductGroupContentAsync());

  return handleDispatchResult(res, onSuccess, onFailure);
};
